import nieuweSportclubApi from "../../../api/nieuweSportclubApi";

export default class BevestigingPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");

        context.setState({
            model: context.props.storeModel
        });
    }

    goToFirstTab() {
        this.redirector.goTo("/nieuweSportclub/organisatie");
    }

    dienIn() {
        const context = this.context;
        const state = context.state;
        const props = context.props;
        const model = state.model;
        const ajaxActions = props.ajaxActions;

        ajaxActions.started();
        nieuweSportclubApi.dienIn(model)
            .then((response) => {
                ajaxActions.ended();
                this.redirector.goTo("/nieuwesportclub/eind");
            })
            .catch((ex) => {
                ajaxActions.failed();
                props.throwException(ex, true);
            });
    }
}